import React, { useState, useEffect } from 'react';
import Dither from './Dither';
import '../App.css'

const Loading = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          return 100;
        }
        return prev + 1;
      });
    }, 20);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (progress >= 100 && !isComplete) {
      setIsComplete(true);
      // Délai avant le fade out
      setTimeout(() => {
        setFadeOut(true);
        // Délai pour l'animation de fade avant de terminer
        setTimeout(() => {
          if (onComplete) onComplete();
        }, 1000);
      }, 500);
    }
  }, [progress, isComplete, onComplete]);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#000000',
      zIndex: 9999,
      opacity: fadeOut ? 0 : 1,
      transition: 'opacity 1s ease-out',
      pointerEvents: fadeOut ? 'none' : 'auto'
    }}>
      {/* Background Dither Effect */}
      <div style={{ 
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%', 
        height: '100%',
        zIndex: 1
      }}>
        <Dither
          waveColor={[0.5, 0.5, 0.5]}
          disableAnimation={false}  
          enableMouseInteraction={true}
          mouseRadius={0.3}
          colorNum={4}
          waveAmplitude={0.3}
          waveFrequency={3}
          waveSpeed={0.05}
        />
      </div>
      
      {/* Loading Content */}
      <div style={{
        position: 'relative',
        zIndex: 2,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none' // Permet l'interaction avec le background Dither
      }}>
        <div style={{
          width: '600px',
          maxWidth: '80vw',
          textAlign: 'center'
        }}>
        <div style={{
          color: '#ffffff',
          fontSize: '32px',
          marginBottom: '50px',
          letterSpacing: '2px'
        }} className='poppins-bold-italic'>
          LOADING
        </div>
        
        <div style={{
          width: '100%',
          height: '2px',
          backgroundColor: '#1a1a1a',
          borderRadius: '1px',
          overflow: 'hidden',
          marginBottom: '30px',
          position: 'relative'
        }}>
          <div style={{
            width: `${Math.min(progress, 100)}%`,
            height: '100%',
            background: 'white',
            borderRadius: '1px',
            transition: 'width 0.1s ease-out',
            boxShadow: '0 0 10px rgba(102, 126, 234, 0.5)'
          }}>
          </div>
        </div>
        
        <div style={{
          color: '#white',
          fontSize: '14px',
          fontWeight: '400',
          letterSpacing: '1px'
        }}>
          {Math.min(progress, 100)}%
        </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
